export default "__VITE_ASSET__e346d328__"